var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2047 9.32669V11.8823C27.0753 12.7783 29.1668 15.3769 29.1668 18.4807V26.7088C29.1668 30.5513 25.9812 33.6667 22.0539 33.6667H7.94816C4.01909 33.6667 0.833496 30.5513 0.833496 26.7088V18.4807C0.833496 15.3769 2.92674 12.7783 5.79564 11.8823V9.32669C5.81258 4.35799 9.92794 0.333344 14.9748 0.333344C20.0893 0.333344 24.2047 4.35799 24.2047 9.32669ZM15.0086 3.23175C18.4466 3.23175 21.2409 5.96453 21.2409 9.32668V11.5228H8.75938V9.29356C8.77631 5.94797 11.5707 3.23175 15.0086 3.23175ZM16.482 24.4249C16.482 25.2365 15.8215 25.8824 14.9917 25.8824C14.1788 25.8824 13.5183 25.2365 13.5183 24.4249V20.7481C13.5183 19.9531 14.1788 19.3071 14.9917 19.3071C15.8215 19.3071 16.482 19.9531 16.482 20.7481V24.4249Z",
    fill: "#EFE690"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.974a4e3aa19566d09c82a3e81d36683d.svg";
export { ForwardRef as ReactComponent };